import { Component, HostBinding, type Signal, computed, contentChild, contentChildren, effect, untracked, Input } from '@angular/core';

import { FormFieldControl } from './form-field-control';
import { FormFieldErrorDirective } from './form-field-error.directive';
import { LabelDirective } from '../label';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'tt-form-field',
  template: `
    <ng-content />

    @switch (hasDisplayedMessage()) {
      @case ('error') {
        <ng-content select="tt-error" />
      }
      @default {
        <ng-content select="tt-hint" />
      }
    }
  `,
  standalone: true,
})
export class FormFieldComponent {
  @HostBinding('class.tt-form-field') get FormFieldClass() {
    return true;
  }

  @Input() withoutFormControl = false;

  public control = contentChild(FormFieldControl);
  public errorChildren = contentChildren(FormFieldErrorDirective);
  public labelChild = contentChild(LabelDirective);

  public hasDisplayedMessage: Signal<'error' | 'hint'> = computed(() => {
    return this.errorChildren() && this.errorChildren().length > 0 && this.control()?.errorState() ? 'error' : 'hint';
  });

  constructor() {
    effect(() => {
      if (!this.control() && !this.withoutFormControl) {
        console.error('tt-form-field must contain a FormFieldControl.');
      } else {
        const label = this.labelChild();
        if (!label) return;

        untracked(() => {
          label.registerControl(this.control());
        });
      }
    });
  }
}
